export const IMAGE_POPUP_WRAPPER_ID = 'image_popup_wrapper';
export const IMAGE_POPUP_OPEN_DATA_ATTRIBUTE = 'data-image-popup-open';
